import React, { Fragment } from 'preact/compat';
import { Field } from 'formik';
import { useSelfServiceFormContext } from './context';
import FormError from '../error';
import FormRequired from '../required';

export default function LegalFields() {
    const {
        links: {
            privacy,
        },
    } = useSelfServiceFormContext();

    return (
        <Fragment>
            <div className='form__field'>
                <label className='toggle-container'>
                    <span className='toggle-container__input'>
                        <Field type='checkbox' name='agreePrivacy' className='toggle  toggle--checkbox' />
                    </span>
                    <span className='toggle-container__label'>
                        By submitting this form, you agree to the Fair Processing of your personal data we will only contact you in respect of your enquiry. Your details will be deleted in accordance with our <a href={privacy} target='_blank' rel='noopener noreferrer'>Fair Processing Notice</a>.
                        <FormRequired />
                    </span>
                </label>
                <FormError name='agreePrivacy' />
            </div>
            <div className='type'>
                <p>Verbal abuse, the use of inappropriate language and or threatening behaviour towards our team and community of brands, will not be tolerated and we reserve the right to refuse to serve you.</p>
                <p>Response emails may be filtered into your junk folder by your email service provider, so please be sure to check there as well.</p>
                <p>If you are getting in touch about a product you purchased, please ensure you have provided all the requested information, including details from the lid (not to be confused with the barcode on the label which we do not require) along with any relevant photographs. Thank you.</p>
            </div>
        </Fragment>
    );
}
